import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnScrollbarComponent } from './fn-scrollbar.component';
export * from  './fn-scrollbar.component';
@NgModule({
	declarations: [FnScrollbarComponent],
	imports: [FormsModule, CommonModule],
	exports: [FnScrollbarComponent],
})
export class FnScrollbarModule {}
